export default __webpack_public_path__ + "static/media/building-right.f55dcdd1.svg";